// GENERATED by scripts/stamp-version.js — do not edit, do not commit.
// Rewritten on every npm start / npm run build / npm test.
export const BUILD_VERSION = "0.1.0-20261105.155748.ed7e642";
export const BUILT_AT = "2026-11-05T10:27:48.537Z";
